import { defineMessages } from 'react-intl';

export default defineMessages({
  hairColor: {
    id: 'cboard.components.HairColor.hairColor',
    defaultMessage: 'Hair Color'
  },
  clearSelection: {
    id: 'cboard.components.HairColor.clearSelection',
    defaultMessage: 'Clear selection'
  }
});
